<template>
  <div class="tech-section">
    <div class="tech-container">
      <div class="tech-title">{{ title }}</div>
      <div class="tech-subtitle">{{ subtitle }}</div>
      <div class="tech-content">
        <div class="tech-content-wrapper">
          <!-- 左侧老式技术部分 -->
          <div class="tech-image-main">
            <div class="main-image-container">
              <img :src="oldTechImage" alt="">
            </div>
            <div class="overlay-container">
              <div>{{ oldTechTitle }}</div>
              <div>
                <div v-for="(item, index) in oldTechList" :key="index"
                  :class="['tech-list-item', index === 0 ? 'first' : '']">
                  <div class="item-header">
                    <div class="icon-container">
                      <img class="full-size" :src="item.icon" alt="">
                    </div>
                    <div class="item-title">{{ item.title }}</div>
                  </div>
                  <div class="item-description">{{ item.description }}</div>
                </div>
              </div>
            </div>
          </div>

          <!-- 右侧新技术部分 -->
          <div class="tech-image-side">
            <div class="side-image-container">
              <img :src="newTechImage" alt="">
            </div>
            <div class="overlay-container right-side-overlay">
              <div class="companion-tech-title">{{ newTechTitle }}</div>
              <div v-for="(item, index) in newTechList" :key="index"
                :class="['tech-list-item', index === 0 ? 'first' : '']">
                <div class="item-header">
                  <div class="icon-container">
                    <img class="full-size" :src="item.icon" alt="">
                  </div>
                  <div class="item-title white-text">{{ item.title }}</div>
                </div>
                <div class="item-description light-text">{{ item.description }}</div>
              </div>
            </div>
          </div>

          <!-- 研发部分 -->
          <div class="tech-image-group research-section">
            <div class="research-bg">
              <img :src="researchBgImage" alt="">
            </div>
            <div class="research-wrapper">
              <div class="research-content">
                <div class="research-title">{{ research.title }}</div>
                <div class="patent-text">{{ research.patentText }}</div>
                <div class="patent-number">{{ research.patentNumber }}</div>
                <div class="patent-stats">
                  <div v-for="(stat, index) in research.stats" :key="index" class="stat-card">
                    <div class="stat-card-bg"></div>
                    <div class="stat-content">
                      <div class="stat-number">{{ stat.number }}</div>
                      <div class="stat-label">{{ stat.label }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="research-image">
                <img :src="researchDecorImage" alt="">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TechSection',
  data() {
    return {
      title: '伴生雾化技术引领者',
      subtitle: '改变老式雾化技术的喷得不全、留死角、挑药剂、易失活、药效持久性差痛点',

      // 老式技术部分
      oldTechImage: require('../assets/home12.png'),
      oldTechTitle: '老式雾化技术',
      oldTechList: [], // 初始化为空数组，将通过API填充

      // 新技术部分
      newTechImage: require('../assets/home10.png'),
      newTechTitle: '伴生雾化技术',
      newTechList: [
        {
          icon: require('../assets/home14.png'),
          title: '不挑药剂',
          description: '药剂上完全不 "挑食"，不管是常见的 84、次氯酸，还是娇贵的生物酶、益生菌，统统完美雾化'
        },
        {
          icon: require('../assets/home14.png'),
          title: '不留死角',
          description: '喷的时候助剂助力雾滴化为长效悬浮的气溶胶，360° 全方位出击，角角落落都能被均匀药雾覆盖'
        },
        {
          icon: require('../assets/home14.png'),
          title: '不限温度',
          description: '全程低温运作，活性成分稳如泰山，一点儿不遭破坏'
        },
        {
          icon: require('../assets/home14.png'),
          title: '不怕药断',
          description: '药效特持久，喷一次，药雾长时间 "在岗"，杀菌消毒、杀虫、除臭除味持续发力，不用反复操作，高效省心。'
        }
      ],

      // 研发部分
      researchBgImage: require('../assets/home9.png'),
      researchDecorImage: require('../assets/home11.png'),
      research: {
        title: '深耕研发',
        patentText: '伴生雾化技术已申请专利',
        patentNumber: 'ZL 2023 1 1183009.6',
        stats: [
          { number: '2', label: '发明专利' },
          { number: '12', label: '实用新型' },
          { number: '13', label: '设计专利' }
        ]
      }
    }
  },
  created() {
    this.getoldTechList()
    this.getnewTechList()
  },
  methods: {
    getoldTechList() {
      // 先获取文章列表
      this.$http.get(`/cms/content/front-list?pageNum=1&pageSize=10&catalogId=652860291186757`).then(res => {
        console.log(res)

        if (res.code === 200 && res.data.rows) {
          // 将API返回的title替换到oldTechList
          this.oldTechList = res.data.rows.map(item => ({
            
            icon: require('../assets/home13.png'), // 保留原来的图标
            title: item.title, 
            description: item.subTitle // 如果API没有subTitle字段，使用默认值
          }))
        }
      }).catch(error => {
        console.error('获取文章列表失败:', error);
      });
    },
    getnewTechList() {
      // 先获取文章列表
      this.$http.get(`/cms/content/front-list?pageNum=1&pageSize=10&catalogId=652860363997253`).then(res => {
        console.log(res)

        if (res.code === 200 && res.data.rows) {
          // 将API返回的title替换到oldTechList
          this.newTechList = res.data.rows.map(item => ({
            
            icon: require('../assets/home14.png'), // 保留原来的图标
            title: item.title, 
            description: item.subTitle // 如果API没有subTitle字段，使用默认值
          }))
        }
      }).catch(error => {
        console.error('获取文章列表失败:', error);
      });
    }
  }
}
</script>

<style scoped>
/* 样式部分保持不变 */
.tech-section {
  height: 801px;
  background: #ffffff;
}

.tech-container {
  padding-top: 100px;
}

.tech-title {
  text-align: center;
  font-weight: bold;
  font-size: 40px;
  color: #000000;
  font-family: SourceHanSansSC, SourceHanSansSC;
  width: 100%;
}

.tech-subtitle {
  font-family: SourceHanSansSC, SourceHanSansSC;
  font-weight: 400;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.85);
  width: 100%;
  text-align: center;
  margin-top: 16px;
}

.tech-content {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 40px;
}

.tech-content-wrapper {
  width: 1430px;
  display: flex;
}

.tech-image-main {
  width: 614px;
  height: 448px;
  position: relative;
  z-index: 10;
  background-size: cover;
}

.tech-image-side {
  width: 614px;
  height: 448px;
  background-size: cover;
  position: relative;
  margin-left: -100px;
  z-index: 9;
}

.overlay-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  font-weight: bold;
  font-size: 28px;
  font-style: normal;
  padding: 28px 0 0 61px;
}

.tech-list-item {
  margin-top: 21px;
  max-width: 100%;
  box-sizing: border-box;
}

.tech-list-item.first {
  margin-top: 17px;
}

.item-header {
  display: flex;
  align-items: center;
}

.icon-container {
  width: 25px;
  height: 25px;
  margin-top: -15px;
}

.full-size {
  width: 100%;
  height: 100%;
}

.item-title {
  line-height: 30px;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.85);
  font-style: normal;
  font-weight: bold;
  margin-left: 6px;
}

.item-description {
  margin-left: 31px;
  color: rgba(0, 0, 0, 0.5);
  font-size: 12px;
  font-weight: 400;
  width: 385px;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

.right-side-overlay {
  padding-left: 159px;
}

.companion-tech-title {
  color: #F9F9F9;
}

.white-text {
  color: #FFFFFF !important;
}

.light-text {
  color: rgba(255, 255, 255, 0.6) !important;
}

.research-section {
  width: 380px;
  height: 448px;
  position: relative;
  left: -86px;
}

.research-bg {
  width: 380px;
  height: 448px;
  position: absolute;
  top: 0;
  left: 0;
}

.research-content {
  width: 294px;
  position: absolute;
  top: 29px;
  right: -78px;
}

.research-title {
  font-size: 28px;
  color: #FFFFFF;
  font-weight: bold;
  width: 100%;
  text-align: center;
}

.patent-text {
  width: 100%;
  text-align: center;
  color: #C0E6B9;
  font-size: 14px;
  margin-top: 9px;
}

.patent-number {
  width: 100%;
  text-align: center;
  color: #C0E6B9;
  font-size: 14px;
}

.patent-stats {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-top: 32px;
}

.stat-card {
  position: relative;
  height: 76px;
  width: 76px;
}

.stat-card-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.7) 0%, rgba(255, 255, 255, 0.1) 100%);
  border-radius: 8px;
  border: 1px solid #FFFFFF;
  opacity: 0.34;
}

.stat-content {
  position: relative;
  z-index: 1;
}

.stat-number {
  font-weight: bold;
  font-size: 32px;
  color: #FFFFFF;
  font-family: Altinn-DINExp, Altinn-DINExp;
  text-align: center;
}

.stat-label {
  font-size: 14px;
  color: #FFFFFF;
  font-family: SourceHanSansSC, SourceHanSansSC;
  text-align: center;
  margin-top: -10px;
}

.main-image-container,
.side-image-container {
  width: 614px;
  height: 448px;
}

.main-image-container img,
.side-image-container img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.research-image {
  position: absolute;
  top: 250px;
  right: -52px;
  z-index: 10;
  width: 232px;
  height: 181px;
}

.research-image img {
  width: 100%;
  height: 100%;
}

@media screen and (max-width: 768px) {
  .tech-section {
    height: auto;
    padding-bottom: 40px;
  }

  .tech-container {
    padding-top: 40px;
  }

  .tech-title {
    font-size: 28px;
    padding: 0 20px;
  }

  .tech-subtitle {
    font-size: 14px;
    padding: 0 20px;
    margin-top: 12px;
  }

  .tech-content {
    margin-top: 20px;
    padding: 0 20px;
  }

  .tech-content-wrapper {
    width: 100%;
    flex-direction: column;
  }

  .tech-image-main,
  .tech-image-side {
    width: 100%;
    height: auto;
    margin-left: 0;
    margin-bottom: 20px;
    background: #fff;
  }

  .main-image-container,
  .side-image-container {
    display: none;
  }

  .overlay-container {
    position: relative;
    padding: 20px;
    height: auto;
    background: #f5f5f5;
    border-radius: 8px;
  }

  .right-side-overlay {
    padding-left: 20px;
    background: #f8fdf9;
  }

  .item-description {
    width: auto;
    max-width: calc(100% - 31px);
    margin-right: 0;
  }

  .research-section {
    width: 100%;
    height: auto;
    left: 0;
    margin-bottom: 20px;
    background: #f8fdf9;
    border-radius: 8px;
  }

  .research-bg {
    display: none;
  }

  .research-content {
    position: relative;
    width: 100%;
    right: 0;
    top: 0;
    padding: 20px;
  }

  .patent-stats {
    flex-wrap: wrap;
    gap: 10px;
    justify-content: center;
  }

  .research-image {
    display: none;
  }

  .stat-card {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 8px;
  }

  .white-text {
    color: rgba(0, 0, 0, 0.85) !important;
  }

  .light-text {
    color: rgba(0, 0, 0, 0.5) !important;
  }

  .companion-tech-title {
    color: rgba(0, 0, 0, 0.85);
  }

  .research-title,
  .stat-number,
  .stat-label {
    color: rgba(0, 0, 0, 0.85);
  }

  .patent-text,
  .patent-number {
    color: rgba(0, 0, 0, 0.6);
  }
}
</style>